import React from "react";

export default function ContentMonetizationExact() {
  return (
    <div className="relative w-full max-w-4xl mx-auto flex flex-col gap-5 md:gap-8">
      <div className="w-full flex flex-col-reverse md:flex-row items-center justify-between gap-10">
        {/* Left Section */}
        <div className="flex flex-col self-start">
          <div className="font-bebas font-normal tracking-wider text-[30px]  lg:text-[50px] leading-[130%] text-[#06382f] mb-6">
            Why <span className="text-[#0E8A43]">Content-Centric</span> <br />
            Monetization is the <span className="text-[#0E8A43]">Future</span>
          </div>

          <ul className="text-[#004D4D] text-base lg:text-lg font-inter font-medium leading-[130%] space-y-6 pl-5 list-disc">
            <li>Readers respond better to contextually embedded formats</li>
            <li>
              Native and story-based modules see{" "}
              <span className="whitespace-nowrap font-semibold text-[darkgreen]">
                3 - 8x engagement
              </span>{" "}
              vs static ads
            </li>
            <li>
              Drives better{" "}
              <span className="font-semibold text-[darkgreen]">
                first-party signal capture
              </span>
              , fueling smarter bidding
            </li>
            <li>
              <span className="font-semibold text-[darkgreen]">
                Incremental monetizable inventory
              </span>{" "}
              without hurting user experience
            </li>
          </ul>
        </div>

        {/* Right Section */}
        <div className="flex flex-col">
          <div className="relative w-full max-w-[350px]">
            <img
              src="./slide3StoryImoji.png"
              alt="content monetization"
              width={350}
              height={350}
              className="w-full h-auto object-contain"
              loading="eager"
            />
          </div>

          <div className="text-[#004D4D] text-base lg:text-lg font-inter font-bold leading-[120%] text-center">
            Young generations <br /> are story focused
          </div>
        </div>
      </div>

      {/* Bottom Line Text */}
      <div className="text-[#004D4D] text-lg md:text-[20px] font-medium font-inter text-left">
        It’s no longer about more ads. It’s about more meaningful content.
      </div>
    </div>
  );
}
